import _ from 'lodash';
import { GET_COLLECTIONS, CREATE_COLLECTIONS } from '../actions/CollectionsActions';

const INITIAL_STATE = {
  data: [],
  headers: [],
  lookupKey: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_COLLECTIONS:

      const data = _.get(action, 'payload.data.data');
      const headers = _.get(action, 'payload.data.headers');
      const lookupKey = _.get(action, 'payload.data.lookupKey');

      return {
        ...state,
        data,
        headers,
        lookupKey,
      };

    case CREATE_COLLECTIONS:
      return {
        ...state,
      };

    default:
      return state;
  }
}
